import { useState } from "react";
import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactPage() {
  const [sending, setSending] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    setSending(true);
    try {
      const payload = Object.fromEntries(new FormData(event.currentTarget).entries());
      const response = await fetch(`${API}/enquiries`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error();
      }
      event.currentTarget.reset();
      toast.success("Thanks — we’ll be in touch shortly.");
    } catch {
      toast.error("We couldn’t send that message. Please try again.");
    } finally {
      setSending(false);
    }
  };
  return (
    <main className="page-shell contact-page" data-testid="contact-page">
      <section className="page-heading">
        <p className="eyebrow">CONTACT RIGHT HIRE</p>
        <h1>LET’S MAKE<br />A <span>START.</span></h1>
        <p>Whether you need a dependable crew or a better next role, speak directly with Paul Pezos, Director.</p>
      </section>
      <section className="contact-layout">
        <div className="contact-details">
          <article data-testid="contact-phone-detail">
            <Phone />
            <div>
              <p className="eyebrow">PAUL PEZOS · DIRECTOR</p>
              <a href="tel:+61432143111" data-testid="contact-phone-link">0432 143 111</a>
            </div>
          </article>
          <article data-testid="contact-email-detail">
            <Mail />
            <div>
              <p className="eyebrow">EMAIL</p>
              <a href="mailto:paul@rhpersonnel.com.au" data-testid="contact-email-link">paul@rhpersonnel.com.au</a>
              <a href="https://righthirepersonnel.com.au" target="_blank" rel="noreferrer" data-testid="contact-website-link">righthirepersonnel.com.au</a>
            </div>
          </article>
          <article data-testid="contact-office-detail">
            <MapPin />
            <div>
              <p className="eyebrow">LOCATION</p>
              <p>Adelaide South Australia</p>
            </div>
          </article>
        </div>
        <form className="industrial-form contact-form" onSubmit={submit} data-testid="contact-enquiry-form">
          <div className="form-grid two">
            <Field label="Name" name="name" required />
            <Field label="Email" name="email" type="email" required />
          </div>
          <Field label="Phone" name="phone" required />
          <label className="field-wrap">
            Enquiry type
            <select className="field-input" name="enquiry_type" data-testid="contact-enquiry-type">
              <option>General enquiry</option>
              <option>Need staff</option>
              <option>Looking for work</option>
              <option>Other</option>
            </select>
          </label>
          <label className="field-label" htmlFor="message">How can we help?</label>
          <textarea id="message" name="message" className="field-input" rows="6" required data-testid="contact-message" />
          <button className="button-primary form-submit" type="submit" disabled={sending} data-testid="contact-submit-button">
            {sending ? "Sending…" : "Send enquiry"}
            <ArrowUpRight size={17} />
          </button>
        </form>
      </section>
    </main>
  );
}
const Field = ({ label, name, type = "text", ...props }) => (
  <label className="field-wrap">
    {label}
    <input className="field-input" name={name} type={type} data-testid={`contact-${name}`} {...props} />
  </label>
);